import { DefaultState } from 'store/types';

export const POST_CORPORATE_CLIENT_REQUEST = 'POST_CORPORATE_CLIENT_REQUEST';
export const POST_CORPORATE_CLIENT_SUCCESS = 'POST_CORPORATE_CLIENT_SUCCESS';
export const POST_CORPORATE_CLIENT_FAILURE = 'POST_CORPORATE_CLIENT_FAILURE';

export interface CorporateClientFrequencyParams {
  days: string[];
  time: string;
}

export interface CorporateClientForm {
  id?: string;
  name: string;
}

export interface PostCorporateClientRow {
  id: string;
  name: string;
}

export interface PostCorporateClientData {
  rows: PostCorporateClientRow[];
  totalCount: number;
}

export type PostCorporateClientState = DefaultState & {
  contents?: PostCorporateClientData;
};

interface PostCorporateClientRequest {
  type: typeof POST_CORPORATE_CLIENT_REQUEST;
}

interface PostCorporateClientSuccess {
  type: typeof POST_CORPORATE_CLIENT_SUCCESS;
  contents: PostCorporateClientData;
}

interface PostCorporateClientFailure {
  type: typeof POST_CORPORATE_CLIENT_FAILURE;
}

export type PostCorporateClientActionTypes = PostCorporateClientRequest | PostCorporateClientSuccess | PostCorporateClientFailure;